<template>
	<div id="fullscreenElementMobile">
		<main v-if="showCommunicationPage" class="main-mobile-proctoring">
			<div class="h-92 inner-first">
				<!-- <div class="d-flex w-100 justify-content-end"> -->

				<div
					class="d-flex justify-content-center position-relative align-items-center text-center w-100"
				>
					<div
						v-if="testDetails.config.dispDuration"
						class="mobileScreen-CT-timing-container d-flex align-items-center"
					>
						<div class="mr-2 pb-1">
							<img
								v-if="
									timeinsecondsfornotificationfunc.imageName == 'whitetimer'
								"
								src="../../assets/mobileScreenIcons/timer-stopwatch.svg"
								alt
							/>
							<img
								v-else
								src="../../assets/mobileScreenIcons/timer-stopwatch-black.svg"
								alt
							/>
						</div>
						<div>
							<span
								class="mobileScreen-CT-stopwatch-number"
								:style="timeinsecondsfornotificationfunc.style"
								>{{ testTimer }}</span
							>
						</div>
					</div>

					<img
						@click="checkAndGoBack()"
						class="go-back-icon"
						src="@/assets/communication/gray-cross.svg"
						alt
					/>
				</div>
				<!-- </div> -->
				<article
					class="proctoring-sub-mob text-center d-flex flex-column align-items-center justify-content-center"
				>
					<article
						v-if="communicationQues.questionBody.questionMedia"
						class="main-question-box-mob w-100 mt-3 position-relative"
					>
						<!-- Clickable header -->
						<!-- COLLAPSE IMAGE -->
						<b-collapse v-model="isOpen" class="collapse-image">
							<div class="box-image mb-2 mt-2">
								<img
									v-if="
										isImage(
											communicationQues.questionBody.questionMediaType,
											returnCurrentQuestion
										)
									"
									:src="communicationQues.questionBody.questionMedia"
									alt
								/>
								<Media
									v-else-if="
										isAudio(communicationQues.questionBody.questionMediaType)
									"
									:kind="'audio'"
									:isMuted="false"
									:src="communicationQues.questionBody.questionMedia"
									:autoplay="false"
									:controls="true"
									:loop="true"
									class="mcqdatacard-audio-2 w-100"
								></Media>
								<Media
									v-else-if="
										isVideo(communicationQues.questionBody.questionMediaType)
									"
									:kind="'video'"
									:isMuted="false"
									:src="communicationQues.questionBody.questionMedia"
									:autoplay="false"
									:controls="true"
									:loop="true"
									class="comm-image-preview"
								></Media>
							</div>
						</b-collapse>
						<div
							class="collapse-header"
							@click="isOpen = !isOpen"
							style="cursor: pointer;"
						>
							<div
								class="d-flex align-items-center justify-content-center"
								style="gap:8px;"
							>
								<img
									v-if="audioAnswered"
									src="@/assets/green-tick-light.svg"
									alt
								/>
								<h2 class="text-h2 fs-14 grayish-text mb-0">
									Question {{ communicationQues.questionNo }}:
								</h2>
							</div>
							<img
								src="@/assets/rotate-icon.svg"
								:class="{ rotate: isOpen }"
								alt
								class="pos-icon"
							/>
						</div>
						<div
							v-html-safe="communicationQues.questionBody.question"
							class="text-h2 fw-700 fs-16 dark-gray mt-2"
						></div>
					</article>
					<div v-else class="mt-4">
						<div
							class="d-flex align-items-center justify-content-center"
							style="gap:8px;"
						>
							<img
								v-if="audioAnswered"
								src="@/assets/green-tick-light.svg"
								alt
							/>
							<h2 class="text-h2 fs-14 grayish-text">
								Question {{ communicationQues.questionNo }}:
							</h2>
						</div>
						<div
							v-html-safe="communicationQues.questionBody.question"
							class="text-h2 fw-700 fs-16 dark-gray mt-2"
						></div>
					</div>
					<div class="screen-box-mob mt-4">
						<div v-if="videoLoading" class="video-black-screen">
							<div class="white-bar-loader">
								<div v-for="i in 8" :key="i"></div>
							</div>
							<div class="text-white-1">Loading...</div>
						</div>
						<video
							ref="camera"
							style="object-fit: cover;"
							id="selfieCam"
							playsinline
							muted
							:src="videoURL"
						></video>
					</div>
					<div
						:style="{
							background: audioBlob || isRecording ? '#20639B14' : '#F4F4F4',
						}"
						class="mob-audio-bar mt-3"
					>
						<!--  -->
						<section v-if="showPlayPause" @click="togglePlay">
							<img v-if="!isPlaying" src="@/assets/communication/play.svg" />
							<img v-else src="@/assets/communication/pause.svg" />
						</section>

						<div ref="waveform" class="waveform"></div>

						<div v-if="showDuration" class="timer font-primary">
							{{ formattedTime }}
						</div>
					</div>
					<h2
						v-if="!audioBlob && !isRecording"
						class="mt-2 text-h2 fs-12 fw-500 error-red font-secondary"
					>
						Please click on mic icon to record answer
					</h2>
					<!-- <h2
						v-else-if="recordingType == 'answered' && audioAnswered"
						class="mt-3 text-h2 fs-14 fw-500 fresh-green font-secondary"
					>
						You have already answered for this question!
					</h2> -->
					<!-- mic icon -->
					<article
						@click="toggleRecording"
						v-if="!audioBlob && !isRecording"
						class="mic-icon d-flex align-items-center justify-content-center mt-3 pointer mx-auto"
					>
						<img src="@/assets/mic.svg" alt="mic icon" />
					</article>
					<div v-else class="position-relative">
						<b-button
							:disabled="(!isRecording && finishUploadCalled) || submittingTest"
							@click="
								(!isRecording && finishUploadCalled) || submittingTest
									? ''
									: toggleRecording()
							"
							class="btn-red d-flex align-items-center mt-3 w-160px justify-content-center"
						>
							<!-- <img
							v-if="recordingType == 'answered' && audioAnswered"
							src="@/assets/reset-white.svg"
							alt
							class="mr-2"
						/> -->
							<h2
								:class="!isRecording && finishUploadCalled && 'hide'"
								class="fs-13 font-secondary pure-white text-h2 font-secondary"
							>
								{{
									audioBlob && !isRecording
										? "Retake Recording"
										: isRecording
										? "Stop Recording"
										: "Start Recording"
								}}
							</h2>
							<div
								v-if="!isRecording && finishUploadCalled"
								class="loader-pos-rec"
							>
								<Loader />
							</div>
						</b-button>
					</div>
					<!-- box collapse -->
				</article>
			</div>
			<hr class="my-0" />
			<div
				class="inner-second p-3 pl-4 pr-4 d-flex justify-content-between bluebtns"
			>
				<b-button
					variant="outline-primary"
					class="w-45"
					@click="checkAndGoBack()"
					>Back</b-button
				>
				<div class="position-relative">
					<b-button
						class="h-100"
						variant="primary"
						@click="
							showSubmitAudio && !finishUploadCalled && !videoSubFail
								? uploadAudio()
								: ''
						"
						:disabled="!showSubmitAudio || finishUploadCalled || videoSubFail"
					>
						<span
							:class="submittingTest && 'hide'"
							class="font-secondary fw-600 fs-13"
						>
							Submit Answer</span
						>
					</b-button>
					<div v-if="submittingTest" class="loader-pos-sub">
						<Loader />
					</div>
				</div>
			</div>
		</main>
		<div
			v-else
			class="mobileScreen-main-container"
			style="background: white; height:100dvh !important;"
		>
			<MobileHeader
				:testTimerData="testTimer"
				:hideAndShow="divTouchesHeader"
				:timeinsecondsfornotificationfunc="timeinsecondsfornotificationfunc"
			/>

			<div
				:style="
					viewAllMarkForLater
						? 'height: calc(100dvh - 150px)'
						: 'height: calc(100dvh - 194px)'
				"
				style="    overflow-y: auto;
    overflow-x: hidden;"
				@scroll="handleScroll($event)"
			>
				<div class="m-3 d-flex align-items-center justify-content-between">
					<div>
						<div class="mobileScreen-TD-head">{{ testDetails.name }}</div>
						<div
							style="width:fit-content"
							class="mobileScreen-CT-attempts mt-1"
						>
							Total Questions : {{ totalQuestionNocode }}
						</div>
					</div>

					<div
						v-if="testDetails.config.dispDuration"
						:style="timeinsecondsfornotificationfunc.style"
						:class="{ hide: divTouchesHeader }"
						class="mobileScreen-CT-timing-container d-flex align-items-center"
					>
						<div class="mr-2 pb-1">
							<img
								v-if="
									timeinsecondsfornotificationfunc.imageName == 'whitetimer'
								"
								src="../../assets/mobileScreenIcons/timer-stopwatch.svg"
								alt
							/>
							<img
								v-else
								src="../../assets/mobileScreenIcons/timer-stopwatch-black.svg"
								alt
							/>
						</div>
						<div>
							<span
								class="mobileScreen-CT-stopwatch-number"
								:style="timeinsecondsfornotificationfunc.style"
								>{{ testTimer }}</span
							>
						</div>
					</div>
				</div>
				<div class="sticky">
					<hr />

					<div class="m-3 d-flex align-items-center justify-content-between">
						<div class="mobileScreen-TS-secName">
							{{ selectedSection.sectionName }}
						</div>

						<div>
							<span class="mr-2 mobileScreen-TS-secNumber">
								{{ sectionId + 1 }}
							</span>
							<span class="mobileScreen-TS-number-font">
								<span class="mr-2">of</span>
								<span>{{ this.sectionDetails.length }}</span>
							</span>
						</div>
					</div>

					<div
						class="mobileScreen-TS-mainSection mt-2 m-3 d-flex align-items-center w-100"
					>
						<div
							@click="prevSection()"
							v-if="sectionId >= 1"
							style="width: 9%;"
							class="pointer"
						>
							<img src="../../assets/mobileScreenIcons/left-arrow.svg" alt />
						</div>
						<div v-else style="width: 9%;" class="pointer">
							<img
								src="../../assets/mobileScreenIcons/left-arrow-disable.svg"
								alt
							/>
						</div>
						<div style="width: 80%;" class="d-flex">
							<div
								v-for="(section, index) in sectionDetails"
								:key="index"
								class="mr-2 pointer"
								:class="
									sectionId == index
										? 'mobileScreen-TS-sections-selected'
										: 'mobileScreen-TS-sections-unSelect'
								"
								:style="{ width: `${100 / sectionDetails.length}%` }"
								@click="selectSectionFunc(index, 0)"
							></div>
						</div>
						<div
							@click="nextSection()"
							v-if="sectionId < sectionDetails.length - 1"
							style="width: 11%;"
							class="pointer"
						>
							<img src="../../assets/mobileScreenIcons/right-arrow.svg" alt />
						</div>
						<div v-else style="width: 11%;" class="pointer">
							<img
								src="../../assets/mobileScreenIcons/right-arrow-disable.svg"
								alt
							/>
						</div>
					</div>
				</div>

				<hr />

				<div class="m-3 d-flex align-items-center justify-content-between">
					<div class="mobileScreen-TS-secName pointer">Questions answered</div>
					<div>
						<span class="mobileScreen-TS-secNumber">
							{{ totalanswered.attemptedQuestions || 0 }}
						</span>
						<span class="mobileScreen-TS-number-font">
							<span>/</span>
							<span>{{ totalQuestionNocode }}</span>
						</span>
					</div>
				</div>

				<div class="d-flex align-items-center">
					<div class="mr-1 ml-3" style="width: 3%;">
						<img src="../../assets/mobileScreenIcons/TS-circle.svg" alt />
					</div>
					<div class="mobileScreen-TS-progress" style="width: 94%;">
						<b-progress
							:value="totalanswered.attemptedQuestions"
							class="w-100"
							:max="totalQuestionNocode"
						></b-progress>
					</div>
					<div class="mr-3 ml-1" style="width: 3%;">
						<img src="../../assets/mobileScreenIcons/TS-flag.svg" alt />
					</div>
				</div>

				<hr />

				<div
					v-if="!viewAllMarkForLater"
					@click="viewAllMarkForLaterQuestions()"
					class="mt-2 d-flex align-items-center justify-content-between m-3"
				>
					<div class="mobileScreen-TS-mark-font">
						Marked for later questions
					</div>

					<div class="mobileScreen-TS-view-font pointer">View</div>
				</div>
				<div
					v-else
					class="mt-2 d-flex align-items-center justify-content-between m-3"
				>
					<div
						@click="viewAllMarkForLater = false"
						class="mobileScreen-TS-mark-font"
					>
						<img
							class="mr-1"
							src="../../assets/mobile-newUI-imgs/mfl-left-arrow.svg"
						/>
						Back
					</div>

					<div class="mobileScreen-TS-view-font pointer"></div>
				</div>

				<hr />

				<!-- design for cards starts from here -->

				<!-- MCQ card -->
				<div v-if="!viewAllMarkForLater && !viewUnAnswered">
					<span
						class="font-poppins fw-500 fs-14 pl-3"
						v-if="
							selectedSection.communicationSection &&
								selectedSection.noOfQuestionsToAnswer
						"
					>
						{{ getAnswerText }}
					</span>
					<div
						v-if="returnCurrentQuestion.questionKey.slice(0, 4) == 'MCQU'"
						class="mobileScreen-TS-cards m-3"
					>
						<div class="d-flex align-items-center m-3 justify-content-between">
							<div class="d-flex align-items-center">
								<div class="mobileScreen-TS-bluecard mr-3">MCQ</div>

								<div class="mobileScreen-TS-bluecard">
									{{ returnCurrentQuestion.questionBody.marks }} Mark
								</div>
							</div>
							<div
								v-if="returnCurrentQuestion.questionBody.config.config.required"
								class="mobileScreen-TS-required-card"
							>
								<img
									src="../../assets/mobileScreenIcons/required-icon.svg"
									alt
								/>
								<span class="ml-2">Required</span>
							</div>
						</div>
						<div class="m-3">
							<div
								v-if="returnCurrentQuestion.questionBody.questionMedia != null"
								class="mt-3"
							>
								<div
									@click.stop.prevent="
										openPreviewMainimage(
											returnCurrentQuestion.questionBody.questionMedia
										)
									"
									v-if="
										isImage(
											returnCurrentQuestion.questionBody.questionMediaType
										)
									"
									class="d-flex align-items-center justify-content-center w-100"
								>
									<img
										class="qb-image-preview w-100"
										:src="returnCurrentQuestion.questionBody.questionMedia"
										alt
									/>
								</div>
								<div
									v-if="
										isAudio(
											returnCurrentQuestion.questionBody.questionMediaType
										)
									"
									class="d-flex align-items-center w-100"
								>
									<Media
										:kind="'audio'"
										:isMuted="false"
										:src="returnCurrentQuestion.questionBody.questionMedia"
										:autoplay="false"
										:controls="true"
										:loop="true"
										class="mcqdatacard-audio-2 w-100"
									></Media>
								</div>
								<div
									v-if="
										isVideo(
											returnCurrentQuestion.questionBody.questionMediaType
										)
									"
									class="d-flex align-items-center w-100"
								>
									<Media
										:kind="'video'"
										:isMuted="false"
										:src="returnCurrentQuestion.questionBody.questionMedia"
										:autoplay="false"
										:controls="true"
										:loop="true"
										class="qb-image-preview w-100"
									></Media>
								</div>
							</div>
							<div class="d-flex my-3">
								<div class="mobileScreen-TS-cards-head">
									Q{{ currentQuestionIndex + 1 }}. &nbsp;
								</div>
								<div
									v-html-safe="returnCurrentQuestion.questionBody.question"
									class="mobileScreen-TS-cards-head"
								></div>
							</div>

							<!-- <div class="mobileScreen-TS-radios">
							<b-form-radio-group
								@change="selectedOption()"
								value-field="value"
								text-field="value"
								name="some-radios"
								v-model="returnCurrentQuestion.answer"
								:options="returnCurrentQuestion.questionBody.options"
								class="mobsec-ques-style radio-btns"
							></b-form-radio-group>
							</div>-->

							<div
								v-if="
									returnCurrentQuestion.questionBody.noOfCorrectOptionsAllowed >
										1
								"
							>
								<b-form-checkbox-group
									@change="selectedOption()"
									v-model="returnCurrentQuestion.answer"
									class="ml-3 pb-2"
									size="sm"
								>
									<b-row
										:class="{
											mr0mln25px: hasAnyMedia,
										}"
									>
										<b-col
											v-for="(option, index) in returnCurrentQuestion
												.questionBody.options"
											:key="index"
											:cols="hasAnyMedia ? 6 : 12"
											:class="{
												'mt-3': hasAnyMedia ? index > 1 : index > 0,
											}"
										>
											<b-form-checkbox
												:value="
													isValueExist(option)
														? option.value
														: option.mediaValue
												"
												:disabled="
													selectedCount ==
														returnCurrentQuestion.questionBody
															.noOfCorrectOptionsAllowed &&
														!returnCurrentQuestion.answer.includes(
															isValueExist(option)
																? option.value
																: option.mediaValue
														)
												"
											>
												<span v-if="isValueExist(option)">{{
													option.value
												}}</span>
												<span
													@click.stop.prevent="openPreview(option.media)"
													v-if="option.media"
													class="option-media-image-mobile option-media-image d-flex position-relative"
												>
													<img
														:src="option.media"
														alt
														class="w-100 h-100 overflow-hidden br-5px"
													/>
												</span>
											</b-form-checkbox>
										</b-col>
									</b-row>
								</b-form-checkbox-group>
							</div>
							<div class="ml-3 pb-2 newblueradios mob-radio-group" v-else>
								<b-form-group>
									<b-form-radio-group
										v-model="returnCurrentQuestion.answer"
										@change="selectedOption()"
										class="checkbox-btns"
									>
										<b-row
											:class="{
												mr0mln25px: hasAnyMedia,
											}"
										>
											<b-col
												v-for="(option, index) in returnCurrentQuestion
													.questionBody.options"
												:key="index"
												:cols="hasAnyMedia ? 6 : 12"
												:class="{
													'mt-3': hasAnyMedia ? index > 1 : index > 0,
												}"
											>
												<b-form-radio
													:value="
														option.value ? option.value : option.mediaValue
													"
												>
													<span v-if="option.value">{{ option.value }}</span>
													<span
														v-if="option.media"
														class="option-media-image-mobile option-media-image d-flex position-relative"
													>
														<img
															@click.stop.prevent="openPreview(option.media)"
															:src="option.media"
															alt
															class="w-100 h-100 overflow-hidden br-5px"
														/>
													</span>
												</b-form-radio>
											</b-col>
										</b-row>
									</b-form-radio-group>
								</b-form-group>
							</div>
						</div>
						<hr />

						<div class="d-flex align-items-center justify-content-between m-3">
							<div class="mobileScreen-TS-mark-later">Mark for later</div>
							<div class="mobileScreen-SC-switch">
								<b-form-checkbox
									v-model="returnCurrentQuestion.answerStatus.later"
									@change="markforLater()"
									switch
									size="sm"
									class="visibility-unselected-profile-switch"
								></b-form-checkbox>
							</div>
						</div>
					</div>

					<!-- descriptive card -->
					<div
						v-if="returnCurrentQuestion.questionKey.slice(0, 4) == 'LONG'"
						class="mobileScreen-TS-cards m-3"
					>
						<div class="d-flex align-items-center m-3 justify-content-between">
							<div class="d-flex align-items-center">
								<div class="mobileScreen-TS-bluecard mr-3">Descriptive</div>

								<div class="mobileScreen-TS-bluecard">
									{{ returnCurrentQuestion.questionBody.marks }} Mark
								</div>
							</div>
							<div
								v-if="returnCurrentQuestion.questionBody.config.config.required"
								class="mobileScreen-TS-required-card"
							>
								<img
									src="../../assets/mobileScreenIcons/required-icon.svg"
									alt
								/>
								<span class="ml-2">Required</span>
							</div>
						</div>
						<div class="m-3">
							<div
								v-if="returnCurrentQuestion.questionBody.questionMedia != null"
								class="mb-3"
							>
								<div
									@click.stop.prevent="
										openPreviewMainimage(
											returnCurrentQuestion.questionBody.questionMedia
										)
									"
									v-if="
										isImage(
											returnCurrentQuestion.questionBody.questionMediaType
										)
									"
									class="d-flex align-items-center justify-content-center w-100"
								>
									<img
										class="qb-image-preview w-100"
										:src="returnCurrentQuestion.questionBody.questionMedia"
										alt
									/>
								</div>
								<div
									v-if="
										isAudio(
											returnCurrentQuestion.questionBody.questionMediaType
										)
									"
									class="d-flex align-items-center w-100"
								>
									<Media
										:kind="'audio'"
										:isMuted="false"
										:src="returnCurrentQuestion.questionBody.questionMedia"
										:autoplay="false"
										:controls="true"
										:loop="true"
										class="mcqdatacard-audio-2 w-100"
									></Media>
								</div>
								<div
									v-if="
										isVideo(
											returnCurrentQuestion.questionBody.questionMediaType
										)
									"
									class="d-flex align-items-center w-100"
								>
									<Media
										:kind="'video'"
										:isMuted="false"
										:src="returnCurrentQuestion.questionBody.questionMedia"
										:autoplay="false"
										:controls="true"
										:loop="true"
										class="qb-image-preview w-100"
									></Media>
								</div>
							</div>
							<div class="d-flex my-3">
								<div class="mobileScreen-TS-cards-head">
									Q{{ currentQuestionIndex + 1 }}.&nbsp;
								</div>
								<div
									v-html-safe="returnCurrentQuestion.questionBody.question"
									class="mobileScreen-TS-cards-head"
								></div>
							</div>

							<div>
								<b-form-textarea
									@keyup="textSearch($event)"
									v-model.trim="returnCurrentQuestion.answer"
									class="mobileScreen-description-card"
									id="textarea"
									placeholder="Enter a description"
									rows="5"
									no-resize
									@copy="preventCopyPaste"
									@cut="preventCopyPaste"
									@paste="preventCopyPaste"
								></b-form-textarea>
							</div>
						</div>
						<hr />

						<div class="d-flex align-items-center justify-content-between m-3">
							<div class="mobileScreen-TS-mark-later">Mark for later</div>
							<div class="mobileScreen-SC-switch">
								<b-form-checkbox
									v-model="returnCurrentQuestion.answerStatus.later"
									@change="markforLater()"
									switch
									size="sm"
									class="visibility-unselected-profile-switch"
								></b-form-checkbox>
							</div>
						</div>
					</div>

					<!-- match the following card -->
					<div
						v-if="returnCurrentQuestion.questionKey.slice(0, 4) == 'MAFO'"
						class="mobileScreen-TS-cards m-3"
					>
						<div class="d-flex align-items-center m-3 justify-content-between">
							<div class="d-flex align-items-center">
								<div class="mobileScreen-TS-bluecard mr-3">
									Match the following
								</div>

								<div class="mobileScreen-TS-bluecard">
									{{ returnCurrentQuestion.questionBody.marks }} Marks
								</div>
							</div>
							<div
								v-if="returnCurrentQuestion.questionBody.config.config.required"
								class="mobileScreen-TS-required-card"
							>
								<img
									src="../../assets/mobileScreenIcons/required-icon.svg"
									alt
								/>
								<span class="ml-2">Required</span>
							</div>
						</div>
						<div class="m-3">
							<div
								v-if="returnCurrentQuestion.questionBody.questionMedia != null"
								class="mt-3"
							>
								<div
									@click.stop.prevent="
										openPreviewMainimage(
											returnCurrentQuestion.questionBody.questionMedia
										)
									"
									v-if="
										isImage(
											returnCurrentQuestion.questionBody.questionMediaType
										)
									"
									class="d-flex align-items-center justify-content-center w-100"
								>
									<img
										class="qb-image-preview w-100"
										:src="returnCurrentQuestion.questionBody.questionMedia"
										alt
									/>
								</div>
								<div
									v-if="
										isAudio(
											returnCurrentQuestion.questionBody.questionMediaType
										)
									"
									class="d-flex align-items-center w-100"
								>
									<Media
										:kind="'audio'"
										:isMuted="false"
										:src="returnCurrentQuestion.questionBody.questionMedia"
										:autoplay="false"
										:controls="true"
										:loop="true"
										class="mcqdatacard-audio-2 w-100"
									></Media>
								</div>
								<div
									v-if="
										isVideo(
											returnCurrentQuestion.questionBody.questionMediaType
										)
									"
									class="d-flex align-items-center w-100"
								>
									<Media
										:kind="'video'"
										:isMuted="false"
										:src="returnCurrentQuestion.questionBody.questionMedia"
										:autoplay="false"
										:controls="true"
										:loop="true"
										class="qb-image-preview w-100"
									></Media>
								</div>
							</div>
							<div class="d-flex my-3">
								<div class="mobileScreen-TS-cards-head">
									Q{{ currentQuestionIndex + 1 }}.&nbsp;
								</div>
								<div
									v-html-safe="returnCurrentQuestion.questionBody.question"
									class="mobileScreen-TS-cards-head"
								></div>
							</div>

							<div class="mobileScreen-TS-mtf-innerCard">
								<div class="d-flex align-items-center w-100">
									<div
										style="width: 50%;"
										class="mobileScreen-TS-mtf-innerCard-head"
									>
										Questions
									</div>
									<div
										style="width: 50%;"
										class="mobileScreen-TS-mtf-innerCard-head"
									>
										Answers
									</div>
								</div>
								<div class="d-flex align-items-center w-100">
									<div style="width: 50%;">
										<div
											v-for="(option, index) in returnCurrentQuestion
												.questionBody.answerKey"
											:key="index"
										>
											<div class="mobileScreen-TS-mtf-subCard text-break w-100">
												{{ option.sideA }}
											</div>
										</div>
									</div>

									<div style="width: 50%;">
										<draggable
											v-model="returnCurrentQuestion.answer"
											:move="handleMove"
											@end="handleDragEnd"
										>
											<transition-group tag="div" class="grid" name="grid">
												<div
													v-for="(item, index) in returnCurrentQuestion.answer"
													:key="index"
													class="d-flex justify-content-between mobileScreen-TS-mtf-subCard pointer"
												>
													<div class="ml-2 text-break w-75">{{ item }}</div>
													<div>
														<img
															src="../../assets/icons/testscreen/sixdotsmobile.svg"
															alt
														/>
													</div>
												</div>
											</transition-group>
										</draggable>
									</div>
								</div>
							</div>
							<div class="mt-2">
								<img
									src="../../assets/mobileScreenIcons/mtf-info-icon.svg"
									alt
								/>
								<span class="ml-3 mobileScreen-TS-mtf-drag-text"
									>Drag to Match the following</span
								>
							</div>
						</div>
						<hr />

						<div class="d-flex align-items-center justify-content-between m-3">
							<div class="mobileScreen-TS-mark-later">Mark for later</div>
							<div class="mobileScreen-SC-switch">
								<b-form-checkbox
									v-model="returnCurrentQuestion.answerStatus.later"
									@change="markforLater()"
									switch
									size="sm"
									class="visibility-unselected-profile-switch"
								></b-form-checkbox>
							</div>
						</div>
					</div>

					<!--communication card -->
					<CommunicationMobile
						v-if="returnCurrentQuestion.questionKey.slice(0, 4) == 'COMU'"
						:questionData="returnCurrentQuestion"
						:currentQuestionIndex="currentQuestionIndex"
						@open-image="
							openPreviewMainimage(
								returnCurrentQuestion.questionBody.questionMedia
							)
						"
						@mark-later="markforLater()"
						@show-communication="goToCommunication(returnCurrentQuestion)"
					/>
				</div>

				<div v-if="viewAllMarkForLater || viewUnAnswered">
					<div
						v-for="(item, index) in allMarkForLaterandUnAnawerQuestions"
						:key="index"
					>
						<div
							v-if="item.questionKey.slice(0, 4) == 'MCQU'"
							class="mobileScreen-TS-cards m-3"
						>
							<div
								class="d-flex align-items-center m-3 justify-content-between"
							>
								<div class="d-flex align-items-center">
									<div class="mobileScreen-TS-bluecard mr-3">MCQ</div>

									<div class="mobileScreen-TS-bluecard">
										{{ item.questionBody.marks }} Mark
									</div>
								</div>
								<div
									v-if="item.questionBody.config.config.required"
									class="mobileScreen-TS-required-card"
								>
									<img
										src="../../assets/mobileScreenIcons/required-icon.svg"
										alt
									/>
									<span class="ml-2">Required</span>
								</div>
							</div>
							<div class="m-3">
								<div class="d-flex">
									<div class="mobileScreen-TS-cards-head">
										Q{{ item.questionNo }}.&nbsp;
									</div>
									<div
										v-html-safe="item.questionBody.question"
										class="mobileScreen-TS-cards-head"
									></div>
								</div>
								<div class="mt-2 mobileScreen-TS-radios">
									<b-form-radio-group
										@change="selectedOptionMark(item)"
										value-field="value"
										text-field="value"
										:name="'some-radios-' + index"
										v-model="item.answer"
										:options="item.questionBody.options"
										class="mobsec-ques-style radio-btns"
									></b-form-radio-group>
								</div>
							</div>
							<hr />

							<div
								class="d-flex align-items-center justify-content-between m-3"
							>
								<div class="mobileScreen-TS-mark-later">Mark for later</div>
								<div
									class="mobileScreen-SC-switch d-flex align-items-center justify-content-between"
								>
									<b-form-checkbox
										v-model="item.answerStatus.later"
										@change="markforLaterView(item)"
										switch
										size="sm"
										class="visibility-unselected-profile-switch"
									></b-form-checkbox>
								</div>
							</div>
						</div>

						<!-- descriptive card -->
						<div
							v-if="item.questionKey.slice(0, 4) == 'LONG'"
							class="mobileScreen-TS-cards m-3"
						>
							<div
								class="d-flex align-items-center m-3 justify-content-between"
							>
								<div class="d-flex align-items-center">
									<div class="mobileScreen-TS-bluecard mr-3">Descriptive</div>

									<div class="mobileScreen-TS-bluecard">
										{{ item.questionBody.marks }} Mark
									</div>
								</div>
								<div
									v-if="item.questionBody.config.config.required"
									class="mobileScreen-TS-required-card"
								>
									<img
										src="../../assets/mobileScreenIcons/required-icon.svg"
										alt
									/>
									<span class="ml-2">Required</span>
								</div>
							</div>
							<div class="m-3">
								<div class="d-flex">
									<div class="mobileScreen-TS-cards-head">
										Q{{ item.questionNo }}.&nbsp;
									</div>
									<div
										v-html-safe="item.questionBody.question"
										class="mobileScreen-TS-cards-head"
									></div>
								</div>

								<div class="mt-2">
									<b-form-textarea
										@keyup="textSearchview(item, $event)"
										v-model.trim="item.answer"
										class="mobileScreen-description-card"
										id="textarea"
										placeholder="Enter a description"
										rows="5"
										no-resize
										@copy="preventCopyPaste"
										@cut="preventCopyPaste"
										@paste="preventCopyPaste"
									></b-form-textarea>
								</div>
							</div>
							<hr />

							<div
								class="d-flex align-items-center justify-content-between m-3"
							>
								<div class="mobileScreen-TS-mark-later">Mark for later</div>
								<div
									class="mobileScreen-SC-switch d-flex align-items-center justify-content-between"
								>
									<b-form-checkbox
										v-model="item.answerStatus.later"
										@change="markforLaterView(item)"
										switch
										size="sm"
										class="visibility-unselected-profile-switch"
									></b-form-checkbox>
								</div>
							</div>
						</div>

						<!-- match the following card -->
						<div
							v-if="item.questionKey.slice(0, 4) == 'MAFO'"
							class="mobileScreen-TS-cards m-3"
						>
							<div
								class="d-flex align-items-center m-3 justify-content-between"
							>
								<div class="d-flex align-items-center">
									<div class="mobileScreen-TS-bluecard mr-3">
										Match the following
									</div>

									<div class="mobileScreen-TS-bluecard">
										{{ item.questionBody.marks }} Marks
									</div>
								</div>
								<div
									v-if="item.questionBody.config.config.required"
									class="mobileScreen-TS-required-card"
								>
									<img
										src="../../assets/mobileScreenIcons/required-icon.svg"
										alt
									/>
									<span class="ml-2">Required</span>
								</div>
							</div>
							<div class="m-3">
								<div class="d-flex">
									<div class="mobileScreen-TS-cards-head">
										Q{{ item.questionNo }}.&nbsp;
									</div>
									<div
										v-html-safe="item.questionBody.question"
										class="mobileScreen-TS-cards-head"
									></div>
								</div>
								<div class="mt-2 mobileScreen-TS-mtf-innerCard">
									<div class="d-flex align-items-center w-100">
										<div
											style="width: 50%;"
											class="mobileScreen-TS-mtf-innerCard-head"
										>
											Questions
										</div>
										<div
											style="width: 50%;"
											class="mobileScreen-TS-mtf-innerCard-head"
										>
											Answers
										</div>
									</div>
									<div class="d-flex align-items-start w-100">
										<div style="width: 50%;">
											<div
												v-for="(option, index) in item.questionBody.answerKey"
												:key="index"
											>
												<div
													class="mobileScreen-TS-mtf-subCard text-break w-7100"
												>
													{{ option.sideA }}
												</div>
											</div>
										</div>

										<div style="width: 50%;">
											<draggable
												v-model="item.answer"
												:move="handleMove"
												@end="handleDragEndMark(item)"
											>
												<transition-group tag="div" class="grid" name="grid">
													<div
														v-for="(item, index) in item.answer"
														:key="index"
														class="d-flex justify-content-between mobileScreen-TS-mtf-subCard pointer"
													>
														<div class="ml-2 text-break w-75">{{ item }}</div>
														<div>
															<img
																src="../../assets/icons/testscreen/sixdotsmobile.svg"
																alt
															/>
														</div>
													</div>
												</transition-group>
											</draggable>
										</div>
									</div>
								</div>
								<div class="mt-2">
									<img
										src="../../assets/mobileScreenIcons/mtf-info-icon.svg"
										alt
									/>
									<span class="ml-3 mobileScreen-TS-mtf-drag-text"
										>Drag to Match the following</span
									>
								</div>
							</div>
							<hr />

							<div
								class="d-flex align-items-center justify-content-between m-3"
							>
								<div class="mobileScreen-TS-mark-later">Mark for later</div>
								<div
									class="mobileScreen-SC-switch d-flex align-items-center justify-content-between"
								>
									<b-form-checkbox
										v-model="item.answerStatus.later"
										@change="markforLaterView(item)"
										switch
										size="sm"
										class="visibility-unselected-profile-switch"
									></b-form-checkbox>
								</div>
							</div>
						</div>

						<!-- communication card -->
						<CommunicationMobile
							v-if="item.questionKey.slice(0, 4) == 'COMU'"
							:questionData="item"
							:currentQuestionIndex="currentQuestionIndex"
							@open-image="
								openPreviewMainimage(item.questionBody.questionMedia)
							"
							@mark-later="markforLater()"
							@show-communication="goToCommunication(item)"
						/>
					</div>
					<div
						v-if="allMarkForLaterandUnAnawerQuestions.length <= 0"
						class="mobileScreen-TS-secName text-center"
					>
						No Questions
					</div>
				</div>

				<!-- pagination starts from here -->
			</div>
			<div
				v-if="!viewAllMarkForLater && !viewUnAnswered"
				class="m-pagination d-flex align-items-center justify-content-center"
			>
				<div
					@click="prevQuetion()"
					v-if="currentQuestionIndex != 0"
					class="mobileScreen-quest-icon mt-1 pointer"
				>
					<img src="../../assets/mobileScreenIcons/left-arrow.svg" alt />
				</div>
				<div v-else class="mobileScreen-quest-icon mt-1 pointer">
					<img
						src="../../assets/mobileScreenIcons/left-arrow-disable.svg"
						alt
					/>
				</div>
				<div
					class="mt-1 mobile-login-sub-font mobileScreen-quest-div ml-2 mr-2"
				>
					Question
					<span class="ml-1 mr-1">{{ this.currentQuestionIndex + 1 }}</span>
					<span class="mr-1">/</span>
					<span>{{ selectedSection.sectionResponse.length }}</span>
				</div>
				<div
					@click="nextQuetion()"
					v-if="
						currentQuestionIndex != selectedSection.sectionResponse.length - 1
					"
					class="mobileScreen-quest-icon mt-1 pointer"
				>
					<img src="../../assets/mobileScreenIcons/right-arrow.svg" alt />
				</div>
				<div v-else class="mobileScreen-quest-icon mt-1 pointer">
					<img
						src="../../assets/mobileScreenIcons/right-arrow-disable.svg"
						alt
					/>
				</div>
			</div>
			<div
				class="mobileScreen-TD-footer mt-2 d-flex align-items-center justify-content-center bluebtns"
			>
				<b-button
					v-if="testDetails.config.includeEndTest"
					@click="endTestPost()"
					style="width: 100%;"
					class="mobileScreen-startBtn"
					>Finish Test</b-button
				>
			</div>
		</div>
		<div
			v-if="leaveTestMobile || notSubWarning"
			class="testscreen-custom-modal"
		>
			<div class="testscreen-modal-content">
				<div
					class="d-flex align-items-center justify-content-center flex-column"
				>
					<div>
						<img
							src="../../assets/mobile-newUI-imgs/new-warning-icon.svg"
							alt
						/>
					</div>

					<div class="mt-4 mobileScreen-modal-head">Alert!</div>

					<div class="mt-3 mobileScreen-modal-subhead text-center">
						{{
							notSubWarning && isRecording
								? "Recording is in progress. Are you sure you want to go back? Your current recording will be lost."
								: notSubWarning
								? "You have a recorded answer that’s not submitted. Do you want to go back or proceed anyway?"
								: "Are you sure you want to leave the test?"
						}}
					</div>

					<div
						class="mt-4 bluebtns d-flex align-items-center justify-content-center flex-column w-100"
					>
						<div class="w-50">
							<b-button
								@click="
									notSubWarning
										? (notSubWarning = false)
										: (leaveTestMobile = false)
								"
								class="mobileScreen-startBtn w-100"
								>Cancel</b-button
							>
						</div>
						<div class="w-50">
							<b-button
								@click="notSubWarning ? handleBack() : leaveTestMobilefunc()"
								class="mobileScreen-leaveBtn mt-3 w-100"
								>{{ notSubWarning ? "Continue" : "Leave Test" }}</b-button
							>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="latermodal" class="testscreen-custom-modal">
			<div class="mobile-testscreen-modal-content">
				<div
					class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
				>
					<div>
						<img
							src="../../assets/mobile-newUI-imgs/new-warning-icon.svg"
							alt
						/>
					</div>
					<div
						class="mobileScreen-modal-head mt-3 d-flex align-items-center justify-content-center"
					>
						Alert !
					</div>
					<div
						class="mobileScreen-modal-subhead mt-4"
						style="font-size: 16px;"
						v-html-safe="laterModalText"
					></div>
					<div
						class="mt-4 bluebtns d-flex align-items-center justify-content-center flex-column w-100"
					>
						<div class="w-50">
							<b-button
								class="mobileScreen-startBtn w-100"
								@click="finishtestlater()"
								>Finish Test</b-button
							>
						</div>
						<div class="w-50">
							<b-button
								@click="latermodal = false"
								class="mobileScreen-leaveBtn mt-3 w-100"
								>Cancel</b-button
							>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="cantendtest" class="testscreen-custom-modal">
			<div class="mobile-testscreen-modal-content">
				<div
					class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
				>
					<div>
						<img
							src="../../assets/mobile-newUI-imgs/new-warning-icon.svg"
							alt
						/>
					</div>
					<div
						class="mobileScreen-modal-head mt-3 d-flex align-items-center justify-content-center"
					>
						Alert !
					</div>
					<div
						class="mobileScreen-modal-subhead mt-4"
						style="font-size: 16px;"
						v-html-safe="requiredText"
					></div>

					<div class="mt-4 mobileScreen-TS-secName text-center w-50">
						<b-button
							class="mobileScreen-startBtn w-100"
							@click="cantendtest = false"
							>Okay</b-button
						>
					</div>
				</div>
			</div>
		</div>
		<div v-if="showFullScreen" class="testscreen-custom-modal">
			<div class="mobile-testscreen-modal-content">
				<div
					class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
				>
					<div>
						<img
							src="../../assets/mobile-newUI-imgs/new-warning-icon.svg"
							alt
						/>
					</div>
					<div
						class="mobileScreen-modal-head mt-3 d-flex align-items-center justify-content-center"
					>
						Alert !
					</div>
					<div class="mobileScreen-modal-subhead mt-4">
						This test requires full screen mode.
					</div>

					<div class="mt-4 mobileScreen-TS-secName text-center w-50">
						<b-button
							class="mobileScreen-startBtn w-100"
							@click="(showFullScreen = false), fullScreenMode()"
							>Okay</b-button
						>
					</div>
				</div>
			</div>
		</div>
		<b-modal
			id="viewimagemodal"
			centered
			hide-footer
			hide-header
			v-model="isImageModalOpen"
			:lazy="true"
			:static="true"
		>
			<div class>
				<img
					:src="previewImage"
					alt="Preview"
					class="h-100 w-100 overflow-hidden border-image"
					v-if="previewImage"
				/>
			</div>
		</b-modal>
		<div
			v-if="isImageModalOpen"
			@click="isImageModalOpen = false"
			class="mcq-image-modalclose pointer"
		>
			<img
				class="rotate-on-hover"
				src="../../assets/newui-img/test-screen/imagexclose.svg"
				alt
			/>
		</div>
		<b-modal
			id="viewimagemodal"
			centered
			hide-footer
			hide-header
			v-model="openPreviewMainimagemodal"
			:lazy="true"
			:static="true"
		>
			<div class>
				<img
					:src="previewMainimage"
					alt="Preview"
					class="h-100 w-100 overflow-hidden border-image"
					v-if="previewMainimage"
				/>
			</div>
		</b-modal>
		<div
			v-if="openPreviewMainimagemodal"
			@click="openPreviewMainimagemodal = false"
			class="mcq-image-modalclose pointer"
		>
			<img
				class="rotate-on-hover"
				src="../../assets/newui-img/test-screen/imagexclose.svg"
				alt
			/>
		</div>
	</div>
</template>

<script>
import { isImage, isVideo, isAudio } from "../../checkFileType";
import { mapGetters, mapState } from "vuex";
import draggable from "vuedraggable";
import testScreen from "../../mixins/testScreen";
import MobileHeader from "./MobileHeader.vue";
import CommuTestMixin from "../../mixins/commutestmixin";
import CommunicationMobile from "@/components/answerCards/communicationMobile.vue";
import {
	// getSectionStats, // Not used directly if we use the same method names, but we DO need to import them
	getSectionStats,
	postSectionStats,
} from "../../apiFunction.js";
export default {
	name: "MsystemCheck",
	components: {
		MobileHeader,
		draggable,
		CommunicationMobile,
	},
	data() {
		return {
			showFullScreen: false,
			leaveTestMobile: false,
			sections: [1, 2, 5, 3, 6, 9, 8, 5],
			selectSection: false,
			viewUnAnswered: false,
			value: 33.333333333,
			isOpen: false,
			viewAllMarkForLater: false,
			max: 50,
			divTouchesHeader: false,
			match: 4,
			viewType: "later",
			futureIndex: 0,
			movingIndex: 0,
			allMarkForLaterandUnAnawerQuestions: [],
			previewImage: null,
			isImageModalOpen: false,
			previewMainimage: null,
			openPreviewMainimagemodal: false,
			sectionIDVal: null,
			// Time Tracking Data
			sectionTimings: {},
			currentSectionStartTime: null,
			areStatsLoaded: false,
		};
	},
	mixins: [testScreen, CommuTestMixin],
	computed: {
		...mapState("sectionVUEX", [
			"openCodingSection",
			"selectedCodingSectionIndex",
		]),
		...mapGetters("testVUEX", {
			questionData: "getQuestionData",
			sectionDetails: "getSectionDetails",
			selectedSection: "getSelectedSection",
		}),
		...mapGetters("sectionVUEX", {
			uuid: "getUUID",
			userID: "getUserID",
		}),
		totalQuestionNocode() {
			let total = 0;
			this.sectionDetails.map((data) => {
				if (!data.codingSection) total = data.sectionResponse.length + total;
			});
			return total;
		},
		returnCurrentQuestion() {
			return this.selectedSection.sectionResponse[this.currentQuestionIndex];
		},
		hasAnyMedia() {
			return this.returnCurrentQuestion.questionBody.options.every(
				(opt) => !!opt.media
			);
		},
		selectedCount() {
			return Array.isArray(this.returnCurrentQuestion.answer)
				? this.returnCurrentQuestion.answer.length
				: 0;
		},
		getAnswerText() {
			let str;
			let max = this.selectedSection.sectionResponse.length;
			let min = this.selectedSection.noOfQuestionsToAnswer;
			console.log(max, min);
			str = `Answer any ${min} out of ${max} Questions:-`;
			if (max == min) str = str.replace("any ", "");
			return str;
		},
		currentTrackingId() {
			if (this.selectedSection && this.selectedSection.sectionID) {
				if (
					this.selectedSection.sectionName === "programming" &&
					this.openCodingSection &&
					this.selectedCodingSectionIndex !== null
				) {
					return `${this.selectedSection.sectionID}_prog_${this.selectedCodingSectionIndex}`;
				}
				return this.selectedSection.sectionID;
			}
			return null;
		},
	},
	watch: {
		sectionId(val) {
			this.sectionIDVal = val;
		},
		"testDetails.testID": {
			handler(val) {
				if (val) {
					console.log("TestID available, initializing stats...", val);
					this.initializeStats();
				}
			},
			immediate: true,
		},
		currentTrackingId(newVal, oldVal) {
			if (oldVal) {
				this.recordSectionTime(oldVal);
			}
			this.currentSectionStartTime = Date.now();
			this.postSectionStats();
		},
		returnCurrentQuestion: {
			handler(newVal) {
				console.log(newVal, Array.isArray(newVal.answer));
				if (
					newVal &&
					newVal.questionKey &&
					newVal.questionBody &&
					newVal.questionBody.noOfCorrectOptionsAllowed > 1 &&
					!newVal.questionKey.startsWith("COMU") &&
					(!Array.isArray(newVal.answer) || !newVal.answer)
				) {
					this.$set(newVal, "answer", []);
				}
			},
			immediate: true,
			deep: true,
		},
		selected() {
			if (this.selected) {
				this.selectedOption();
			}
		},
	},
	mounted() {
		if (!this.returnCurrentQuestion.questionKey.startsWith("COMU")) {
			if (!Array.isArray(this.returnCurrentQuestion.answer)) {
				this.$set(this.returnCurrentQuestion, "answer", []);
			}
			if (
				this.returnCurrentQuestion &&
				this.returnCurrentQuestion.questionBody &&
				this.returnCurrentQuestion.questionBody.noOfCorrectOptionsAllowed > 1 &&
				(!Array.isArray(this.returnCurrentQuestion.answer) ||
					!this.returnCurrentQuestion.answer)
			) {
				this.$set(this.returnCurrentQuestion, "answer", []);
			}
		}
		// if(this.returnCurrentQuestion.answerStatus.attempted){
		// 	this.getAudioData(this.returnCurrentQuestion);
		// }
		if (!localStorage.getItem("testFinished")) {
			document.addEventListener(
				"fullscreenchange",
				this.handleFullScreenChange
			);
			document.addEventListener(
				"mozfullscreenchange",
				this.handleFullScreenChange
			);
			document.addEventListener(
				"webkitfullscreenchange",
				this.handleFullScreenChange
			);
			document.addEventListener(
				"msfullscreenchange",
				this.handleFullScreenChange
			);
			this.showFullScreen = true;
			console.log(
				this.sectionId,
				this.sectionDetails,
				this.currentQuestionIndex
			);
		}

		// Add visibility change listener (Critical for Mobile/iOS where beforeunload is flaky)
		document.addEventListener("visibilitychange", this.handleVisibilityChange);
	},
	beforeDestroy() {
		this.postSectionStats();
		document.removeEventListener(
			"visibilitychange",
			this.handleVisibilityChange
		);
	},
	created() {
		if (localStorage.getItem("testFinished")) {
			this.$router.push({ name: "TestClosed" });
		} else {
			console.log(this.testDetails);
			this.selectSectionFunc(this.sectionId, this.currentQuestionIndex);
			this.currentQuestion(this.currentQuestionIndex);
			let payload = {
				topicID: this.testDetails.topicID,
				testID: this.testDetails.testID,
				groupID: this.testDetails.groupID,
				attemptNo: this.testDetails.attemptNo,
			};
			this.$store.dispatch("testVUEX/testCount", payload);
			payload.userID = this.userID;
			this.$store.dispatch("testVUEX/getTestResponse", payload);
		}
		this.sectionIDVal = this.sectionId;
	},
	methods: {
		handleBeforeUnload() {
			this.postSectionStats();
			return null;
		},
		handleVisibilityChange() {
			if (document.visibilityState === "hidden") {
				console.log("App backgrounded (visibility hidden), saving stats...");
				this.postSectionStats();
			}
		},
		initializeStats() {
			// Initialize from LocalStorage
			const storedTimings = localStorage.getItem(
				`sectionTimings_${this.testDetails.testID}`
			);
			if (storedTimings) {
				try {
					this.sectionTimings = JSON.parse(storedTimings);
					console.log("Loaded local stats:", this.sectionTimings);
				} catch (e) {
					console.error("Failed to parse stored timings", e);
				}
			}
			// Fetch from server
			this.getSectionStats();
		},
		recordSectionTime(sectionID) {
			if (!this.currentSectionStartTime) return;
			const now = Date.now();
			const duration = now - this.currentSectionStartTime;
			if (!this.sectionTimings[sectionID]) {
				this.$set(this.sectionTimings, sectionID, 0);
			}
			this.sectionTimings[sectionID] += duration;
			this.currentSectionStartTime = now;

			// Save to LocalStorage
			localStorage.setItem(
				`sectionTimings_${this.testDetails.testID}`,
				JSON.stringify(this.sectionTimings)
			);
		},
		async getSectionStats() {
			try {
				let payload = {
					topicID: this.testDetails.topicID,
					testID: this.testDetails.testID,
					groupID: this.testDetails.groupID,
					candidateID: this.userID,
					attemptNo: this.testDetails.attemptNo,
					licenseKey: this.licenseKey,
				};
				const res = await getSectionStats(payload);
				console.log(res);
				if (res.status == 200 && res.data.data) {
					const statsArray = res.data.data.sectionStats || res.data.data;

					if (Array.isArray(statsArray)) {
						const timings = {};
						statsArray.forEach((stat) => {
							let key = stat.sectionID;
							if (stat.isProgramming) {
								if (
									stat.parentSectionId &&
									stat.programmingIndex !== undefined
								) {
									key = `${stat.parentSectionId}_prog_${stat.programmingIndex}`;
								} else {
									if (this.sectionDetails) {
										const parent = this.sectionDetails.find(
											(p) =>
												p.sectionResponse &&
												p.sectionResponse.some(
													(child) => child.sectionID === stat.sectionID
												)
										);
										if (parent) {
											const index = parent.sectionResponse.findIndex(
												(child) => child.sectionID === stat.sectionID
											);
											if (index !== -1) {
												key = `${parent.sectionID}_prog_${index}`;
											}
										}
									}
								}
							}

							if (key && stat.totalTimeMs !== undefined) {
								timings[key] = stat.totalTimeMs;
							}
						});

						// Merge with LocalStorage (Priority to max value)
						const storedTimings = localStorage.getItem(
							`sectionTimings_${this.testDetails.testID}`
						);
						if (storedTimings) {
							try {
								const localTimings = JSON.parse(storedTimings);
								Object.keys(localTimings).forEach((sectionID) => {
									const localVal = localTimings[sectionID] || 0;
									const serverVal = timings[sectionID] || 0;
									timings[sectionID] = Math.max(localVal, serverVal);
								});
							} catch (e) {
								console.error("Failed to merge local timings", e);
							}
						}

						this.sectionTimings = timings;
					}
				}
				this.areStatsLoaded = true;
			} catch (error) {
				console.log(error);
			}
		},
		async postSectionStats() {
			// if (!this.areStatsLoaded) return;
			// Record current time before posting
			if (this.currentTrackingId) {
				this.recordSectionTime(this.currentTrackingId);
			}

			try {
				let payload = {
					topicID: this.testDetails.topicID,
					testID: this.testDetails.testID,
					groupID: this.testDetails.groupID,
					candidateID: this.userID,
					attemptNo: this.testDetails.attemptNo,
					licenseKey: this.licenseKey,
					sectionStats: this.getSectionAnalysis(),
				};
				const res = await postSectionStats(payload);
				console.log(res);
			} catch (error) {
				console.log(error);
			}
		},
		getSectionAnalysis() {
			const analysis = Object.keys(this.sectionTimings).map((key) => {
				const totalTimeMs = this.sectionTimings[key];
				let sectionName = "Unknown";
				let questionCount = 1;
				let sectionID = key;
				let extra = {};

				if (key.includes("_prog_")) {
					const [parentId, subIndex] = key.split("_prog_");
					sectionID = parentId;

					const parentSection = this.sectionDetails.find(
						(s) => s.sectionID === parentId
					);
					if (
						parentSection &&
						parentSection.sectionResponse &&
						parentSection.sectionResponse[subIndex]
					) {
						const childSection = parentSection.sectionResponse[subIndex];
						if (childSection.sectionID) {
							sectionID = childSection.sectionID;
						}

						sectionName = `Programming: ${childSection.sectionName}`;
						// questionCount = childSection.sectionResponse ? childSection.sectionResponse.length : 1;
						if (childSection.sectionResponse) {
							questionCount = childSection.sectionResponse.filter(
								(q) => q.answerStatus && q.answerStatus.attempted
							).length;
						} else {
							questionCount = 0;
						}

						extra = {
							programmingIndex: parseInt(subIndex),
							isProgramming: true,
							parentSectionId: parentId,
						};
					} else {
						sectionName = `Programming Sub-section ${parseInt(subIndex) + 1}`;
						extra = {
							programmingIndex: parseInt(subIndex),
							isProgramming: true,
							parentSectionId: parentId,
						};
					}
				} else {
					if (this.sectionDetails) {
						const section = this.sectionDetails.find(
							(s) => s.sectionID === key
						);
						if (section) {
							sectionName = section.sectionName;
							// questionCount = section.sectionResponse ? section.sectionResponse.length : 1;
							if (section.sectionResponse) {
								questionCount = section.sectionResponse.filter(
									(q) => q.answerStatus && q.answerStatus.attempted
								).length;
							} else {
								questionCount = 0;
							}
						}
					}
				}

				if (questionCount === 0) questionCount = 1; // Avoid division by zero

				return {
					sectionID,
					sectionName,
					...extra,
					totalTimeMs,
					totalTimeSeconds: (totalTimeMs / 1000).toFixed(2),
					avgTimePerQuestionMs: totalTimeMs / questionCount,
					avgTimePerQuestionSeconds: (
						totalTimeMs /
						questionCount /
						1000
					).toFixed(2),
				};
			});

			// Aggregate programming sections
			const programmingParentId = "PROGRAMMINGSECTION";
			const progTotalTime = analysis.reduce((acc, curr) => {
				if (
					curr.isProgramming &&
					curr.parentSectionId === programmingParentId
				) {
					return acc + (curr.totalTimeMs || 0);
				}
				return acc;
			}, 0);

			if (progTotalTime > 0) {
				const parentIndex = analysis.findIndex(
					(a) => a.sectionID === programmingParentId && !a.isProgramming
				);
				if (parentIndex !== -1) {
					analysis[parentIndex].totalTimeMs += progTotalTime;
					analysis[parentIndex].totalTimeSeconds = (
						analysis[parentIndex].totalTimeMs / 1000
					).toFixed(2);
				} else {
					analysis.push({
						sectionID: programmingParentId,
						sectionName: "Programming Section (Total)",
						totalTimeMs: progTotalTime,
						totalTimeSeconds: (progTotalTime / 1000).toFixed(2),
						avgTimePerQuestionMs: 0,
						avgTimePerQuestionSeconds: "0.00",
					});
				}
			}

			return analysis;
		},
		// Overriding mixin methods
		posttimereveryminute(data) {
			this.postSectionStats();
			if (testScreen.methods && testScreen.methods.posttimereveryminute) {
				testScreen.methods.posttimereveryminute.call(this, data);
			}
		},
		finishTest() {
			if (this.currentTrackingId) {
				this.recordSectionTime(this.currentTrackingId);
			}
			console.log("Section Analysis Mobile:", this.getSectionAnalysis());

			// Save stats before finishing
			this.postSectionStats();

			// Clear LocalStorage
			localStorage.removeItem("testStarted");
			localStorage.removeItem("proctertimer");
			localStorage.removeItem(`sectionTimings_${this.testDetails.testID}`);
			localStorage.setItem("testFinished", true);

			if (window.opener)
				window.opener.postMessage({ testSubmitted: true }, "*");
			window.removeEventListener("beforeunload", this.handleBeforeUnload);
			document.removeEventListener(
				"visibilitychange",
				this.handleVisibilityChange
			);

			this.$router.push(
				{
					path: "/finishtest",
				},
				() => {
					this.$router.go(0);
				}
			);
			this.Loaderstatus = false;
		},
		isValueExist(option) {
			return (
				option.value != "" && option.value != null && option.value != undefined
			);
		},
		goToCommunication(data) {
			console.log(data, ";HGF");
			let quesData = data;
			// quesData.questionNo = index;
			this.isOpen = false;
			this.showCommunication(quesData);
		},
		getOptionKey(option) {
			return option.value && option.value.trim() !== ""
				? option.value
				: option.mediaValue;
		},
		openPreviewMainimage(imageUrl) {
			this.previewMainimage = imageUrl;
			this.openPreviewMainimagemodal = true;
		},
		openPreview(imageUrl) {
			this.previewImage = imageUrl;
			this.isImageModalOpen = true;
		},
		fullScreenMode() {
			const fullscreenElement = document.getElementById(
				"fullscreenElementMobile"
			);
			if (fullscreenElement.requestFullscreen) {
				fullscreenElement.requestFullscreen();
			} else if (fullscreenElement.mozRequestFullScreen) {
				// Firefox
				fullscreenElement.mozRequestFullScreen();
			} else if (fullscreenElement.webkitRequestFullscreen) {
				// Chrome, Safari and Opera
				fullscreenElement.webkitRequestFullscreen();
			} else if (fullscreenElement.msRequestFullscreen) {
				// IE/Edge
				fullscreenElement.msRequestFullscreen();
			}
		},
		handleFullScreenChange() {
			console.log("screen");
			if (
				document.fullscreenElement ||
				document.mozFullScreenElement ||
				document.webkitFullscreenElement ||
				document.msFullscreenElement
			) {
				return;
			} else {
				this.leaveTestMobile = false;
				this.latermodal = false;
				this.cantendtest = false;
				this.showFullScreen = true;
			}
		},
		saveOnview(data) {
			console.log(data, this.viewAllMarkForLater);
			if (this.viewUnAnswered) {
				this.viewUnAnsweredQuestions();
			}
			if (this.viewUnAnswered) {
				this.viewUnAnsweredQuestions();
			}
		},
		isImage,
		isVideo,
		isAudio,
		viewUnAnsweredQuestions() {
			this.allMarkForLaterandUnAnawerQuestions = [];
			this.viewType = "UnAnswered";
			this.viewUnAnswered = !this.viewUnAnswered;
			this.viewAllMarkForLater = false;
			this.selectedSection.sectionResponse.map((data) => {
				if (this.viewType == "UnAnswered") {
					if (!data.answerStatus.attempted) {
						this.allMarkForLaterandUnAnawerQuestions.push(
							JSON.parse(JSON.stringify(data))
						);
					}
				}
			});
			console.log(this.allMarkForLaterandUnAnawerQuestions);
		},
		viewAllMarkForLaterQuestions() {
			this.allMarkForLaterandUnAnawerQuestions = [];
			this.viewType = "later";
			this.viewAllMarkForLater = true;
			this.viewUnAnswered = false;
			this.selectedSection.sectionResponse.map((data) => {
				if (this.viewType == "later") {
					if (data.answerStatus.later) {
						this.allMarkForLaterandUnAnawerQuestions.push(
							JSON.parse(JSON.stringify(data))
						);
					}
				}
			});
			console.log(this.allMarkForLaterandUnAnawerQuestions);
		},
		nextSection() {
			this.viewAllMarkForLater = false;
			this.viewUnAnswered = false;
			let section = this.sectionId + 1;
			this.$store.commit("sectionVUEX/prevnextbtnstatus", section);
			this.$store.commit(
				"testVUEX/saveSelectedSection",
				this.sectionDetails[section]
			);
			this.$store.commit("sectionVUEX/currentQuestionIndex", 0);
		},
		prevSection() {
			this.viewAllMarkForLater = false;
			this.viewUnAnswered = false;
			let section = this.sectionId - 1;
			this.$store.commit("sectionVUEX/prevnextbtnstatus", section);
			this.$store.commit(
				"testVUEX/saveSelectedSection",
				this.sectionDetails[section]
			);
			this.$store.commit("sectionVUEX/currentQuestionIndex", 0);
		},
		handleScroll(event) {
			if (event.target.scrollTop >= 16) {
				this.divTouchesHeader = true;
			} else {
				this.divTouchesHeader = false;
			}
		},
		leaveTestMobilefunc() {
			this.$router.push({
				path: "/",
				query: {
					uuid: this.uuid,
				},
			});
		},
		leavetestFunc() {
			this.leaveTestMobile = true;
		},
		handleMove(e) {
			const { index, futureIndex } = e.draggedContext;
			this.movingIndex = index;
			this.futureIndex = futureIndex;
			return false; // disable sort
		},
		handleDragEnd() {
			console.log(this.returnCurrentQuestion.answer);
			this.futureItem = this.returnCurrentQuestion.answer[this.futureIndex];
			this.movingItem = this.returnCurrentQuestion.answer[this.movingIndex];
			const _items = Object.assign([], this.returnCurrentQuestion.answer);
			_items[this.futureIndex] = this.movingItem;
			_items[this.movingIndex] = this.futureItem;
			this.returnCurrentQuestion.answer = _items;
			this.returnCurrentQuestion.answerStatus.unattempted = false;
			this.returnCurrentQuestion.answerStatus.attempted = true;
			const payload = {
				topicID: this.testDetails.topicID,
				testID: this.testDetails.testID,
				groupID: this.testDetails.groupID,
				sectionID: this.selectedSection.sectionID,
				questionKey: this.returnCurrentQuestion.questionKey,
				answer: this.returnCurrentQuestion.answer,
				answerStatus: this.returnCurrentQuestion.answerStatus,
				attemptNo: this.testDetails.attemptNo,
			};
			this.$store.dispatch("testVUEX/saveAnswer", payload);
			this.$store.commit("testVUEX/updateSectionDetails", payload);
		},
		handleDragEndMark(data) {
			this.futureItem = data.answer[this.futureIndex];
			this.movingItem = data.answer[this.movingIndex];
			const _items = Object.assign([], data.answer);
			_items[this.futureIndex] = this.movingItem;
			_items[this.movingIndex] = this.futureItem;
			data.answer = _items;
			data.answerStatus.unattempted = false;
			data.answerStatus.attempted = true;
			let payload = {
				topicID: this.testDetails.topicID,
				testID: this.testDetails.testID,
				groupID: this.testDetails.groupID,
				sectionID: this.selectedSection.sectionID,
				questionKey: data.questionKey,
				answer: data.answer,
				answerStatus: data.answerStatus,
				attemptNo: this.testDetails.attemptNo,
			};
			this.$store.dispatch("testVUEX/saveAnswer", payload);
			this.$store.commit("testVUEX/updateSectionDetails", payload);
		},

		textSearch() {
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.saveCurrentAnswer();
			}, 500);
		},
		textSearchview(data) {
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.saveCurrentAnswerview(data);
			}, 500);
		},
		saveCurrentAnswerview(data) {
			if (data.answer == "") {
				data.answerStatus.active = true;
				data.answerStatus.unattempted = true;
				data.answerStatus.attempted = false;
			} else {
				data.answerStatus.active = true;
				data.answerStatus.unattempted = false;
				data.answerStatus.attempted = true;
			}
			let payload = {
				topicID: this.testDetails.topicID,
				testID: this.testDetails.testID,
				groupID: this.testDetails.groupID,
				sectionID: this.selectedSection.sectionID,
				questionKey: data.questionKey,
				answer: data.answer,
				answerStatus: data.answerStatus,
				attemptNo: this.testDetails.attemptNo,
			};
			this.$store.dispatch("testVUEX/saveAnswer", payload);
			this.$store.commit("testVUEX/updateSectionDetails", payload);
		},
		saveCurrentAnswer() {
			if (this.returnCurrentQuestion.answer == "") {
				this.returnCurrentQuestion.answerStatus.active = true;
				this.returnCurrentQuestion.answerStatus.unattempted = true;
				this.returnCurrentQuestion.answerStatus.attempted = false;
			} else {
				this.returnCurrentQuestion.answerStatus.active = true;
				this.returnCurrentQuestion.answerStatus.unattempted = false;
				this.returnCurrentQuestion.answerStatus.attempted = true;
			}
			let payload = {
				topicID: this.testDetails.topicID,
				testID: this.testDetails.testID,
				groupID: this.testDetails.groupID,
				sectionID: this.selectedSection.sectionID,
				questionKey: this.returnCurrentQuestion.questionKey,
				answer: this.returnCurrentQuestion.answer,
				answerStatus: this.returnCurrentQuestion.answerStatus,
				attemptNo: this.testDetails.attemptNo,
			};
			this.$store.dispatch("testVUEX/saveAnswer", payload);
			this.$store.commit("testVUEX/updateSectionDetails", payload);
		},
		preventCopyPaste(event) {
			event.preventDefault();
		},
		prevQuetion() {
			let currentQuestionIndex = this.currentQuestionIndex - 1;
			this.$store.commit(
				"sectionVUEX/currentQuestionIndex",
				currentQuestionIndex
			);
		},
		nextQuetion() {
			let currentQuestionIndex = this.currentQuestionIndex + 1;
			this.$store.commit(
				"sectionVUEX/currentQuestionIndex",
				currentQuestionIndex
			);
		},
		selectSectionFunc(index, questionIndex) {
			this.viewAllMarkForLater = false;
			this.viewUnAnswered = false;
			this.$store.commit("sectionVUEX/prevnextbtnstatus", index);
			this.$store.commit(
				"testVUEX/saveSelectedSection",
				this.sectionDetails[index]
			);
			this.$store.commit("sectionVUEX/currentQuestionIndex", questionIndex);
		},
		currentQuestion(index) {
			this.$store.commit("sectionVUEX/currentQuestionIndex", index);
		},
		selectedOption() {
			if (
				this.returnCurrentQuestion.questionBody.noOfCorrectOptionsAllowed > 1 &&
				typeof this.returnCurrentQuestion.answer === "string"
			) {
				this.returnCurrentQuestion.answer = [this.returnCurrentQuestion.answer];
			}

			const noAnswer =
				!this.returnCurrentQuestion.answer ||
				(Array.isArray(this.returnCurrentQuestion.answer) &&
					this.returnCurrentQuestion.answer.length === 0);

			this.returnCurrentQuestion.answerStatus.active = true;
			this.returnCurrentQuestion.answerStatus.unattempted = noAnswer;
			this.returnCurrentQuestion.answerStatus.attempted = !noAnswer;

			let payload = {
				topicID: this.testDetails.topicID,
				testID: this.testDetails.testID,
				groupID: this.testDetails.groupID,
				sectionID: this.selectedSection.sectionID,
				questionKey: this.returnCurrentQuestion.questionKey,
				answer: this.returnCurrentQuestion.answer,
				answerStatus: this.returnCurrentQuestion.answerStatus,
				attemptNo: this.testDetails.attemptNo,
			};
			this.$store.dispatch("testVUEX/saveAnswer", payload);
			this.$store.commit("testVUEX/updateSectionDetails", payload);
		},
		selectedOptionMark(item) {
			console.log(item);
			item.answerStatus.unattempted = false;
			item.answerStatus.attempted = true;
			let payload = {
				topicID: this.testDetails.topicID,
				testID: this.testDetails.testID,
				groupID: this.testDetails.groupID,
				sectionID: this.selectedSection.sectionID,
				questionKey: item.questionKey,
				answer: item.answer,
				answerStatus: item.answerStatus,
				attemptNo: this.testDetails.attemptNo,
			};
			this.$store.dispatch("testVUEX/saveAnswer", payload);
			this.$store.commit("testVUEX/updateSectionDetails", payload);
		},
		markforLater() {
			let payload = {
				topicID: this.testDetails.topicID,
				testID: this.testDetails.testID,
				groupID: this.testDetails.groupID,
				sectionID: this.selectedSection.sectionID,
				questionKey: this.returnCurrentQuestion.questionKey,
				answer: this.returnCurrentQuestion.answer,
				answerStatus: this.returnCurrentQuestion.answerStatus,
				attemptNo: this.testDetails.attemptNo,
				// quesNo: this.currentQuestionIndex + 1,
			};
			// console.log(payload.quesNo, 'questionNOoooooooooooooooooooo')
			this.$store.dispatch("testVUEX/saveAnswer", payload);
			// this.$store.commit("testVUEX/updateSectionDetails", payload);
		},
		markforLaterView(item) {
			let payload = {
				topicID: this.testDetails.topicID,
				testID: this.testDetails.testID,
				groupID: this.testDetails.groupID,
				sectionID: this.selectedSection.sectionID,
				questionKey: item.questionKey,
				answer: item.answer,
				answerStatus: item.answerStatus,
				attemptNo: this.testDetails.attemptNo,
			};
			this.$store.dispatch("testVUEX/saveAnswer", payload);
			this.$store.commit("testVUEX/updateSectionDetails", payload);
		},
	},
};
</script>

<style scoped>
.screen-box-mob video {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
	transform: scaleX(-1);
}
.mr0mln25px {
	margin-right: 0;
	margin-left: -25px;
}
.option-media-image-mobile {
	width: 110px;
	height: 110px;
}
.mobileScreen-TS-progress .progress {
	height: 9px !important;
	border: none;
	background-color: #d9d9d9 !important;
}

.mobileScreen-TS-progress .progress-bar {
	border-radius: 20px !important;
	background: linear-gradient(
		90deg,
		#2b5bba 8.16%,
		rgba(38, 97, 212, 0.49) 80.61%
	) !important;
}

.testscreen-custom-modal {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(0, 0, 0, 0.5);
	/* Semi-transparent background overlay */
	z-index: 1500;
}

.testscreen-modal-content {
	background-color: #fff;
	border: 1px solid #ccc;
	border-radius: 1.5%;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
	max-width: 90%;
	height: 400px;
	overflow: auto;
	padding: 10px;
	position: relative;
	width: 650px;
}
.main-mobile-proctoring {
	background: #f7f9fc;
	height: 100vh;
}

.inner-first {
	padding: 15px;
}

.inner-second {
	height: 8%;
	background: #ffff;
}

.mob-audio-bar {
	display: flex;
	align-items: baseline;
	justify-content: space-between;
	width: 380px;
	background: #20639b14;
	border-radius: 100px;
	padding: 4px 20px;
	height: 69px;
}

.proctoring-sub-mob {
	/* take full height of screen */
	display: flex;
	flex-direction: column;
	justify-content: center;
	/* centers vertically */
}

.screen-box-mob {
	width: 90%;
	/* adjusts with screen */
	max-width: 400px;
	aspect-ratio: 16 / 9;
	border-radius: 8px;
	overflow: hidden;
	background: #000;
	position: relative;
	margin: auto;
}

.main-question-box-mob {
	border: 1px solid #7a7a7a33;
	background: #ffffff;
	padding: 10px;
	border-radius: 12px;
	transition: all 0.3s ease;
	position: relative;
}

.box-image {
	width: 100%;
	height: 140px;
	background: #20639b1a;
	border-radius: 4px;
	overflow: hidden;
}

.box-image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

/* Rotate arrow */
.rotate {
	transform: rotate(180deg);
	transition: transform 0.3s ease;
}
.pos-icon {
	position: absolute;

	bottom: -12px;
}
.go-back-icon {
	position: absolute;
	right: 16px;
}
</style>
